import { ChartService } from './../../services/webFeeder/sckt-chart.service';
import { Subscription , of } from 'rxjs';
import { TokenService } from '@services/webFeeder/token.service';
import { NotificationsService } from 'angular2-notifications';
import { AbstractItem } from '@business/base/abstract-item';
import { AutoLogoutService } from './../../auth/auto-logout-service.service';
import { SidebarService } from '@services/sidebar.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { AuthenticationService } from '@services/authentication.service';
import { LoginWsResponse } from '@model/webFeeder/loginws-response.model';
import { Constants } from '@utils/constants';

@Component({
  selector: 'app-modal-trading-view',
  templateUrl: './modal-trading-view.component.html'
})
export class ModalTradingViewComponent extends AbstractItem implements OnInit, OnDestroy {

  title = 'GRÁFICOS';

  private symbol;
  private windowActive: Window;
  customGraphicToken = null;
  subscriptions: Array<Subscription> = [];

  constructor(
    public dialogRef: MatDialogRef<ModalTradingViewComponent>,
    public wksService: WorkspaceNewService,
    private sidebarService: SidebarService,
    private configService: ConfigService,
    private _autoLogoutService: AutoLogoutService,
    private authSvc: AuthenticationService,
    private notificationService: NotificationsService,
    private tokenService: TokenService,
    private chartService: ChartService,
    workspaceService: WorkspaceNewService,
    dialog: MatDialog,
    itemService: AbstractItemService,
    private _authenticationService: AuthenticationService,
  ) {
    super(workspaceService, dialog, itemService);
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
  }

  @HostListener('mousemove')
  onMouseMove() {
    if (this.configService.isAuthenticadSystem()) {
      this._autoLogoutService.resetTime();
    }
  }

  @HostListener('click')
  onClick() {
    if (this.configService.isAuthenticadSystem()) {
      this._autoLogoutService.resetTime();
    }
  }

  ngOnInit() {
    this.wksService._openTradingView$.subscribe(res => {
      if (!res) {
        this.closeSheet();
      }
    });

    if (this.configService.isLoginTypeWSO2()) {
      this.subscriptions.push(this.authSvc.iAuthStrategy.refresh()
        .subscribe(data => {
          if (data.access_token) {
            this.customGraphicToken = data.access_token;
          } else {
            this.onTokenError();
          }
        }, () => {
          this.onTokenError();
        }));
    } else {
      this.subscriptions.push(this._authenticationService.loginWS(this.configService.getGuidUser())
        .subscribe((resp: LoginWsResponse) => {
          if (resp && (resp.error === false || resp.error === 'false') && resp.token) {
            this.customGraphicToken = resp.token;
          } else if (resp && resp.codeMessage === true) {
            this.customGraphicToken = resp.tokenWS;
          } else {
            this.onTokenError();
          }
        }, () => {
          this.onTokenError();
        }));
    }
  }

  onTokenError() {
    this.close();
    this.notificationService.error('', 'Não foi possível abrir o gráfico!');
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }

  closeSheet() {
    if (this.windowActive) {
      this.windowActive.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  expand() {
    if (!window.closed) {
      const options = 'width=1203px, height=768px';
      const token = this.customGraphicToken;
      const newChartID = this.chartService.getNewChartId();
      if (this.symbol) {
        const parameters = 'chart?symbol=' + this.symbol + '&chartid=' + newChartID + '&token=' + token;
        this.windowActive = window.open(parameters, '', options);
      } else {
        const parameters = 'chart?chartid=' + newChartID + '&token=' + token;
        this.windowActive = window.open(parameters, '', options);
      }
      this.sidebarService.saveDetachedWindow(this.windowActive);
      this.dialogRef.close();
    }
  }
}
